import { formatCurrencyValues } from "../../utils/convertUtils";

const mapCard = (json) => {
    const {
        AccountID,
        TaxonomyCode,
        Debit,
        Credit,
        SumBalDebit,
        SumBalCredit,
        AccumulatedDebit,
        AccumulatedCredit,
        CurrencyOptions,
        AccountDescription,
    } = json;

    return [
        [
            {
                labels: ["Account ID"],
                value: `${AccountID} - ${AccountDescription ? AccountDescription : "N/A"}`,
                type: "string",
                basis: "50%",
            },
        ],
        [
            {
                labels: ["Taxonomy Code"],
                value: TaxonomyCode,
                type: "string",
                basis: "5%",
                align: "center",
            },
        ],
        [
            {
                labels: ["Debit amount"],
                value: formatCurrencyValues(CurrencyOptions, Debit),
                type: "currency",
            },
        ],
        [
            {
                labels: ["Credit amount"],
                value: formatCurrencyValues(CurrencyOptions, Credit),
                type: "currency",
            },
        ],
        [
            {
                labels: ["Accumulated Balance Debit"],
                value: formatCurrencyValues(CurrencyOptions, AccumulatedDebit),
                type: "currency",
            },
        ],
        [
            {
                labels: ["Accumulated Balance Credit"],
                value: formatCurrencyValues(CurrencyOptions, AccumulatedCredit),
                type: "currency",
            },
        ],
        [
            {
                labels: ["Accumulated Balance Debit"],
                value: formatCurrencyValues(CurrencyOptions, SumBalDebit),
                type: "currency",
            },
        ],
        [
            {
                labels: ["Accumulated Balance Credit"],
                value: formatCurrencyValues(CurrencyOptions, SumBalCredit),
                type: "currency",
            },
        ],
    ];
};

const header = [
    { label: ["Account Id"], align: "left", basis: "50%" },
    { label: ["Taxonomy"], align: "center", basis: "5%" },
    { label: ["Period Debit"], align: "right" },
    { label: ["Period Credit"], align: "right" },
    { label: ["Accumulated Debit"], align: "right" },
    { label: ["Accumulated Credit"], align: "right" },
    { label: ["Debit Balance"], align: "right" },
    { label: ["Credit Balance"], align: "right" },
];

const mapper = (json, card) => {
    return {
        ...json,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
        link: {
            to: "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix/reports/nc_statement_accounts_accumulated",
            filter: [
                { filters: [{ value: json.AccountID }], column: "AccountID" },
                {
                    filters: [{ value: `0#${json.MaxPeriod}` }],
                    column: "Period",
                    operator: "between",
                },
            ],
        },
    };
};

const nctrialbalanceMapper = {
    map: mapper,
    header,
};

export default nctrialbalanceMapper;
